import React from 'react';
import { Icon } from '@hz-design-system/web-ui';

const ListingVerifiedSellerBadge: React.FC = () => <Icon name="checkmark-circle" color="background-info-default" />;

export default ListingVerifiedSellerBadge;
